import {useGTMDispatch} from './react-gtm-hook/index'
import {transformAlgoliaItemsForGA4} from './utils'

export const useViewItemListTracking = () => {
  const sendDataToGTM = useGTMDispatch();
  const sendViewItemListData = (viewItemListData) => {
    const {items, listType, pageId, region, badges} = viewItemListData
    setTimeout(() => {
      try {
        const itemListName = listType?.name ?? listType
        const _items = transformAlgoliaItemsForGA4(items, null, {itemListName, badges})
        let listId;
        if (pageId) {
          listId = pageId;
        } else {
          listId = listType?.id ?? 'Search Results'
        }
        sendDataToGTM({
          event: 'view_item_list',
          ecommerce: {
            item_list_id: _items.length === 0 ? 'Search No Results Page' : listId,
            item_list_name: listType?.name ?? listType,
            region,
            ...(_items.length > 0 ? {items: _items} : {}),
            item_list_total: _items.length,
          }
        })
      } catch (error) {
        console.error('useViewItemListTracking error within setTimeout: ' + error.message);
      }
    }, 0);
  };
  return sendViewItemListData;
};